import React, { useCallback } from 'react';
import { FeedbackFilters } from '../FeedbackDashboardFilterBar';
import { LoadFiltersApi } from 'donor/portal/pages/FeedbackDashboard/tempData';
import EditAndSaveRow from './EditAndSaveRow';

export interface ApplyFilters {
  donorNameFilters: FeedbackFilters;
  relationshipFilters: FeedbackFilters;
  portfolioNameFilters: FeedbackFilters;
  cyclesFilters: FeedbackFilters;
  statusFilters: FeedbackFilters;
  staffFilters: FeedbackFilters;
  dueDateFilters: FeedbackFilters;
  charityNavigatorFilters: FeedbackFilters;
  yearFilters: FeedbackFilters;
}

interface FilterProps {
  usersName: string;
  index: number;
  filterType: keyof LoadFiltersApi;
  onApply: (filters: ApplyFilters) => unknown;
  onSave: (
    id: string | number,
    index: number,
    usersName: string,
    filterName: string,
    filterType: keyof LoadFiltersApi,
  ) => unknown;
  onDelete: (index: number, filterType: keyof LoadFiltersApi) => unknown;
  handleDialogClose: () => unknown;
}

export type ShowFilterProps =
  | (FilterProps &
      ApplyFilters & {
        mode?: 'edit' | 'show';
        id: string | number;
        filterName: string;
        createdDate: string;
      })
  | (FilterProps &
      Partial<ApplyFilters> & {
        mode: 'add';
        id?: string | number;
        filterName?: string;
        createdDate?: string;
      });

const ShowFilter: React.FC<ShowFilterProps> = ({
  id,
  index,
  filterName = '',
  filterType,
  mode = 'show',
  usersName,
  createdDate,
  donorNameFilters,
  relationshipFilters,
  portfolioNameFilters,
  cyclesFilters,
  statusFilters,
  staffFilters,
  dueDateFilters,
  yearFilters,
  handleDialogClose,
  onApply,
  onSave,
  onDelete,
}) => {
  const handleApplyFilters = useCallback(() => {
    onApply({
      donorNameFilters: donorNameFilters || {},
      relationshipFilters: relationshipFilters || {},
      portfolioNameFilters: portfolioNameFilters || {},
      cyclesFilters: cyclesFilters || {},
      statusFilters: statusFilters || {},
      staffFilters: staffFilters || {},
      dueDateFilters: dueDateFilters || {},
      charityNavigatorFilters: {},
      yearFilters: yearFilters || {},
    });
    handleDialogClose();
  }, [
    donorNameFilters,
    relationshipFilters,
    portfolioNameFilters,
    cyclesFilters,
    statusFilters,
    staffFilters,
    dueDateFilters,
    yearFilters,
  ]);

  const handleSave = useCallback(
    (name: string) => {
      if (name.length < 3) return;
      onSave(id || -1, index, usersName, name, filterType);
    },
    [onSave, id, index, usersName, filterType],
  );

  const handleDelete = useCallback(() => {
    onDelete(index, filterType);
  }, [onDelete, id, index, filterType]);

  return (
    <EditAndSaveRow
      createdDate={createdDate}
      description={undefined}
      onClick={handleApplyFilters}
      onDelete={handleDelete}
      onSave={handleSave}
      title={filterName}
      userName={usersName}
    />
  );
};

export default ShowFilter;
